import _ from 'lodash'

export function truncate(
  text,
  options = {
    length: 35,
    omission: '...',
    separator: ' ',
  },
  withLastWord = true,
) {
  if (text.length <= length) {
    return text
  }

  if (!withLastWord) {
    return _.truncate(text, options)
  }

  const words = text.trim().split(options.separator)
  const lastWord = words[words.length - 1]

  const truncatedStart = _.truncate(text, options).trim()

  return `${truncatedStart}${omission} ${lastWord}`
}

export function validateNIF(nif) {
  const nifRegex = /^([0-9]{8}[A-Z]|[XYZ][0-9]{7}[A-Z])$/
  return nifRegex.test(nif)
}
